var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Logical NDR/NPR")]), _vm._v(" "), _c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Business Configuration:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-location-arrow'></i>",
      "right": _vm.srLoader
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.BusinessConfigArray,
      "selected-option": _vm.BusinessConfigdata,
      "name": "BusinessConfig",
      "id": "BusinessConfig",
      "placeholder": "Select Business Configuration"
    },
    on: {
      "select": _vm.getBusinessConfig
    },
    model: {
      value: (_vm.BusinessConfig),
      callback: function($$v) {
        _vm.BusinessConfig = $$v
      },
      expression: "BusinessConfig"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.BusinessConfig')),
      expression: "errors.has('form-1.BusinessConfig')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select\n                                    Business Configuration")])], 1)]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select Parent NDR/NPR:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-location-arrow'></i>",
      "right": _vm.srLoader2
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.ParentNDRArray,
      "selected-option": _vm.ParentNDRdata,
      "name": "ParentNDR",
      "placeholder": "Select Parent NDR/NPR"
    },
    on: {
      "select": _vm.getParentNDR
    },
    model: {
      value: (_vm.ParentNDR),
      callback: function($$v) {
        _vm.ParentNDR = $$v
      },
      expression: "ParentNDR"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ParentNDR')),
      expression: "errors.has('form-1.ParentNDR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Parent\n                                    NDR/NPR")])], 1)]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select Child NDR/NPR:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search",
      "type": "text",
      "name": "search",
      "placeholder": "Search NDR/NPR"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), (_vm.ChildNDRArray1.length > 0 && _vm.BusinessConfig && _vm.ParentNDR) ? _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "height": "200px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.ChildNDRArray1), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "list-style": "none"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ischeck),
        expression: "item.ischeck"
      }],
      key: index,
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "id": "ischeck",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.ischeck) ? _vm._i(item.ischeck, null) > -1 : (item.ischeck)
      },
      on: {
        "change": function($event) {
          _vm.CheckSelected(item)
        },
        "__c": function($event) {
          var $$a = item.ischeck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (item.ischeck = $$a.concat([$$v]))
            } else {
              $$i > -1 && (item.ischeck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.ischeck = $$c
          }
        }
      }
    }), _vm._v("\n                                    " + _vm._s(item.text) + "\n                                ")])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading == true
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v("    \n                                "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading == true
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c2cf80","hasScoped":true}!./src/views/components/LogicalNDR/LogicalNDR.component.html
// module id = 1383
// module chunks = 1